import React, { useContext } from "react";
import Card from "../../components/Card/Card";
import { CardGridWrapper } from "../../components/Card/CardGridWrapper";
import TitleBanner from "../../components/TitleBanner/TitleBanner";
import { AppContext } from "../../context";

function Cart({ productsInCart, handleSubmitCart, updateList, setUpdateList }) {
  const info = useContext(AppContext);

  return (
    <>
      {" "}
      {/* <button
    onClick={() => {
      setIsMessagesVisible(true);
    }}
    >
    Mensagens
  </button> */}
      {/* no products in the cart */}
      {productsInCart?.length === 0 ? (
        <TitleBanner
          color="lylac"
          title={info.t("emptyCart")}
          subtitle={info.t("emptyCart")}
        />
      ) : (
        <TitleBanner
          color="lylac"
          title={info.t("selection")}
          subtitle={info.t("submitCart")}
        >
          {productsInCart?.length !== 0 && (
            <button
              className="ahp-button"
              type="button"
              onClick={() => {
                handleSubmitCart();
              }}
              style={{ margin: "1.7rem 1.5rem 1.7rem 1.5rem" }}
            >
              {info.t("submit")}
            </button>
          )}
        </TitleBanner>
      )}
      {/* {createReservationInfo()} */}
      <CardGridWrapper>
        {productsInCart?.length > 0 &&
          productsInCart?.map((product, index) => (
            <Card
              entity={product.type}
              product={product}
              key={"cart" + index}
              removeBtn={true}
              updateList={updateList}
              setUpdateList={setUpdateList}
              context="cart"
            />
          ))}
      </CardGridWrapper>
    </>
  );
}

export default Cart;
